import { Controller } from "@hotwired/stimulus";

// Auto-refresh metrics every 30 seconds for real-time updates
export default class extends Controller {
  static values = {
    url: String,
    interval: { type: Number, default: 30000 }, // 30 seconds
  };

  connect() {
    this.startRefresh();
  }

  disconnect() {
    this.stopRefresh();
  }

  startRefresh() {
    this.stopRefresh(); // Clear any existing interval

    this.refreshTimer = setInterval(() => {
      this.refresh();
    }, this.intervalValue);
  }

  stopRefresh() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer);
      this.refreshTimer = null;
    }
  }

  refresh() {
    // Only refresh if the metrics tab is visible
    if (this.isTabVisible()) {
      const frame = this.element.querySelector(
        'turbo-frame[id="metrics_frame"]'
      );
      if (frame) {
        // Get current filter from active button or frame src
        const currentRange = this.getCurrentRange();
        const baseUrl = this.urlValue.split("?")[0]; // Remove any existing params
        frame.src = `${baseUrl}?range=${currentRange}`;
      }
    }
  }

  getCurrentRange() {
    // Check which time range button is currently active
    const activeButton = this.element.querySelector(
      ".bg-indigo-600.text-white"
    );
    if (activeButton) {
      return activeButton.textContent.trim();
    }

    // Fallback to checking frame src for range parameter
    const frame = this.element.querySelector('turbo-frame[id="metrics_frame"]');
    if (frame && frame.src) {
      const url = new URL(frame.src);
      return url.searchParams.get("range") || "24h";
    }

    // Default fallback
    return "24h";
  }

  isTabVisible() {
    // Check if the metrics tab is currently active
    const metricsTab = document.querySelector('[data-tab-id="metrics"]');
    return metricsTab && metricsTab.classList.contains("border-indigo-500");
  }

  // Pause refresh when user is interacting with time range selector
  pauseRefresh() {
    this.stopRefresh();

    // Resume after 5 seconds of inactivity
    setTimeout(() => {
      this.startRefresh();
    }, 5000);
  }
}
